import LocalStorageService from "../services/localstorage.service";

function useDataStorage(prefix: string = "store") {
  const _dataStorage = new LocalStorageService(prefix);
  return _dataStorage;
}

export { useDataStorage };
